import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EmailSummaryDto } from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
  SendStatusChipComponent,
  SimpleChipComponent,
} from '@workspace/ng-aura';
import { EmailActionDisplayPipe, EmailTagDisplayPipe } from '@workspace/ng-data-access';
import { EmailColumnKey } from './abstract-emails-data-table.component';
import { EmailsDataTableFilterCoreComponent } from './filter/emails-data-table-filter.component';

@Component({
  selector: 'core-emails-data-table',
  standalone: true,
  templateUrl: './emails-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    TitleCasePipe,
    LowerCasePipe,
    EmailActionDisplayPipe,
    EmailTagDisplayPipe,
    MatIconModule,
    MatTooltipModule,
    EmailsDataTableFilterCoreComponent,
    AvatarAuraComponent,
    RouterModule,
    SendStatusChipComponent,
    SimpleChipComponent,
  ],
})
export class EmailsDataTableCoreComponent extends BaseDataTableCoreComponent<
  EmailSummaryDto,
  EmailColumnKey
> {}
